import { createFileRoute } from '@tanstack/react-router'

import { SpecSectionPage } from '@/components/spec/spec-section-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/projects/$projectRef_/cahier_/$key')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: SpecSectionRoutePage,
})

function SpecSectionRoutePage() {
  const { projectRef, key } = Route.useParams()
  useFollowProjectClient(projectRef)
  // La clé change : on repart de la section, sans état de la précédente.
  return <SpecSectionPage key={key} projectRef={projectRef} sectionKey={key} />
}
